export default class DateUtils {
    public static CastBRStringToDate(date: string): Date {
        if (!date)
            return new Date(Date.UTC(0, 0, 0));

        let [datePart, timePart] = date.split(' ');
        if (!datePart) return new Date(Date.UTC(0, 0, 0));

        let parts = datePart.split('/');
        if (parts.length < 3)
            return new Date(Date.UTC(0, 0, 0));

        let day = Number.parseInt(parts[0]);
        let month = Number.parseInt(parts[1]);
        let year = Number.parseInt(parts[2]);

        if (isNaN(day) || isNaN(month) || isNaN(year))
            return new Date(Date.UTC(0, 0, 0));

        let hours = 0, minutes = 0, seconds = 0;
        if (timePart) {
            let timeParts = timePart.split(':');
            hours = Number.parseInt(timeParts[0]) || 0;
            minutes = Number.parseInt(timeParts[1]) || 0;
            seconds = Number.parseInt(timeParts[2]) || 0;
        }

        return new Date(year, month - 1, day, hours, minutes, seconds);
    }

    public static CastStringToDate(date: string): Date {
        if (!date)
            return new Date(Date.UTC(0, 0, 0));

        if (date.indexOf('-') == -1 && date.indexOf('/') != -1)
            return DateUtils.CastBRStringToDate(date);

        let parts = date.split('-');

        if (parts.length < 3)
            return new Date(Date.UTC(0, 0, 0));

        let time = parts[2].split(' ');

        if (time.length == 1 && time[0].length > 4)
            time = parts[2].split('T');

        if (time.length > 1)
            parts[2] = time.shift()!;

        if (time.length == 0 || time[0].indexOf(':') == -1)
            time = ["0", "0", "0"];
        else
            time = time[0].split(':');

        let dateParts: number[] = [];

        for (let p of parts) {
            let r = Number.parseInt(p);

            if (r == Number.NaN)
                return new Date(Date.UTC(0, 0, 0));

            dateParts.push(r);
        }

        let hours: number[] = [];
        for (let p of time) {
            let r = Number.parseInt(p);

            if (r == Number.NaN)
                hours.push(0);
            else
                hours.push(r);

        }

        while (hours.length < 3)
            hours.push(0);

        return new Date(dateParts[0], dateParts[1] - 1, dateParts[2], hours[0], hours[1], hours[2]);

    }

    public static CastAPItoUI(date: string): string {
        return DateUtils.CastDateToString(DateUtils.CastStringToDate(date));
    }


    public static CastDateToString(date: Date) {
        let day = date.getDate().toString().padStart(2, '0');
        let month = (date.getMonth() + 1).toString().padStart(2, '0');
        let year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    public static CastDateWithTimeToString(date: Date) {
        let day = date.getDate().toString().padStart(2, '0');
        let month = (date.getMonth() + 1).toString().padStart(2, '0');
        let year = date.getFullYear();
        let hours = date.getHours().toString().padStart(2, '0');
        let minutes = date.getMinutes().toString().padStart(2, '0');

        return `${day}/${month}/${year} às ${hours}h${minutes}`;
    }

    public static CastDateToAPIString(date: Date) {
        let day = date.getDate().toString().padStart(2, '0');
        let month = (date.getMonth() + 1).toString().padStart(2, '0');
        let year = date.getFullYear();

        return `${year}-${month}-${day}`;
    }

    public static RemoveTime(date: Date) {
        let day = date.getDate();
        let month = date.getMonth();
        let year = date.getFullYear();

        return new Date(Date.UTC(year, month, day));
    }

    public static GerDiffDays(start: Date, end: Date): number 
    {
        const DayMS = 1000 * 60 * 60 * 24;

        const d1 = new Date(start.getFullYear(), start.getMonth(), start.getDate());
        const d2 = new Date(end.getFullYear(), end.getMonth(), end.getDate());

        const diffMS = d2.getTime() - d1.getTime();

        return Math.floor(diffMS / DayMS);
    }
}